import { FormGroup } from '@angular/forms';

export class Account {
    public id: string;
    public externalAccountId: string;
    public username: string;
    public email: string;
    public password: string;
    public phone: string;
    public sector: string;
    public type: number;

    public static parse(form: FormGroup): Account {
        const account = new Account();
        account.email = form.value.email;
        account.password = form.value.passwordGroup.password;
        account.phone = form.value.phone;
        account.sector = form.value.sector;
        switch (form.value.signupType) {
            case "employer":
                account.type = 1;
                break;
            case "candidate":
                account.type = 0;
                break;
            default:
                throw new Error(`Account Type ${form.value.signupType} is not supported`);
        }

        return account;
    }
}
